import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'
import Settings from 'Event/Step3/TechCheck/Buttons/StartButton/StartButtonConfig/Settings'
import Styling from 'Event/Step3/TechCheck/Buttons/StartButton/StartButtonConfig/Styling'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import {useAddTranslation} from 'Event/LanguageProvider'

export default function StartButtonConfig() {
  const save = useSaveTemplate()
  const {techCheck} = useTemplate()
  const {
    form: {register, watch, control, setValue},
  } = useConfig()

  const addTranslation = useAddTranslation()

  const handleSave = (data: any) => {
    const text = replaceAtPath(data, 'text', '{{tech_check_start_button_text}}')

    save({
      techCheck: {
        startButton: data,
      },
      localization: addTranslation({
        tech_check_start_button_text: text ?? '',
      }),
    })
  }

  // Need to tell Config we're updating techCheck.startButton explicitly, because
  // the input names are just `text`, `link`. Without specifing the values here,
  // useAutoUpdate() would mess up previews.
  const current = {
    techCheck: {
      startButton: watch(),
    },
  }

  return (
    <Config title="Submit Button" onSave={handleSave} preview={current}>
      <SettingsPanel>
        <Settings
          register={register}
          button={techCheck.startButton}
          control={control}
          watch={watch}
        />
      </SettingsPanel>
      <StylingPanel>
        <Styling
          control={control}
          button={techCheck.startButton}
          watch={watch}
          setValue={setValue}
        />
      </StylingPanel>
    </Config>
  )
}
